import React from 'react';
import { Check, ArrowRight, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const handlePurchase = () => {
    // Track AddToCart event before redirecting
    trackAddToCart();
    // Redirect to Shopify cart
    window.location.href = 'https://grupogeo0610.com/cart/46880967393429:1';
  };
  return <section id="pricing-section" className="py-24 bg-gradient-to-b from-gray-50 to-white" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-132">
          <div className="bg-teal-600 p-4 text-center" data-id="element-133">
            <p className="text-teal-50 font-medium text-sm tracking-wide uppercase" data-id="element-134">
              Oferta Especial de Lanzamiento
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-135">
            <div className="text-center mb-10" data-id="element-136">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-137">
                Empieza hoy mismo
              </h2>
              <p className="text-gray-600 text-lg" data-id="element-138">
                Si este PDF te ahorra 2 semanas de confusión, ya se pagó solo.
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-139">
              <div className="text-center" data-id="element-140">
                <span className="text-6xl font-bold text-gray-900 tracking-tight" data-id="element-141">
                  $6.39
                </span>
                <span className="text-gray-500 text-xl ml-2" data-id="element-142">USD</span>
                <p className="text-sm text-gray-400 mt-2" data-id="element-143">
                  Pago único. Acceso de por vida.
                </p>
              </div>
            </div>

            <div className="space-y-4 max-w-md mx-auto mb-10" data-id="element-144">
              {['Método 3x3 completo', 'Tablero de 30 días', 'Plantillas de copy y ventas', 'Guiones para DMs', 'Checklist de entrega'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-145">
                  <div className="bg-green-100 rounded-full p-1" data-id="element-146">
                    <Check className="w-4 h-4 text-green-600" data-id="element-147" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-148">{item}</span>
                </div>)}
            </div>

            <div className="text-center space-y-4" data-id="element-149">
              <button onClick={handlePurchase} className="w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-12 rounded-xl text-xl transition-all shadow-lg shadow-orange-500/30 flex items-center justify-center gap-2 mx-auto transform hover:-translate-y-1" data-id="element-150">
                Comprar Ahora
                <ArrowRight className="w-6 h-6" data-id="element-151" />
              </button>

              <div className="flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-152">
                <Lock className="w-3 h-3" data-id="element-153" />
                <span data-id="element-154">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 text-center border-t border-gray-100" data-id="element-155">
            <p className="text-gray-600 text-sm" data-id="element-156">
              Si estás lista para salir del "algún día" y convertir 5 horas en
              movimiento real, este es tu momento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}